import { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row, Tab, Tabs } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { fetchCustomerById, updateCustomerMeterById } from '../../api/customer';
import { createInstallationByCustomerId } from '../../api/installation';

const CustomerMeterForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [customer, setCustomer] = useState(null);
    const [loading, setLoading] = useState(true);
    const [form, setForm] = useState(null);
    const [files, setFiles] = useState([]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleFileChange = (e) => {
        setFiles([...e.target.files]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            form.verificationStatus = 'Done';
            await updateCustomerMeterById(id, form);
            await createInstallationByCustomerId(id);
            Swal.fire({
                icon: 'success',
                title: 'Successful!',
                text: 'Customer profile has been verified successfully.',
                confirmButtonText: 'OK'
            }).then(() => {
                navigate('/crm/verification/pending');
            });
        } catch (err) {
            console.error('Error submitting application:', err);
            alert('There was an error. Please try again.');
        }
    };

    useEffect(() => {
        const loadInspection = async () => {
            try {
                const res = await fetchCustomerById(id);
                const inspection = res.data.data;
                setCustomer(inspection);
                setForm(inspection);
            } catch (err) {
                console.error('Error fetching inspection:', err);
            } finally {
                setLoading(false);
            }
        };
        loadInspection();
    }, [id]);

    if (loading || !form) return <p>Loading...</p>;
    if (!customer) return <p>Inspection or customer not found.</p>;

    return (
        <div className="container">
            <h3 className="mb-4">Edit Inspection Schedule</h3>

            <Card className="mb-4">
                <Card.Header className="bg-primary text-white">Customer Info</Card.Header>
                <Card.Body>
                    <p><strong>Name:</strong> {customer.firstName} {customer.lastName}</p>
                    <p><strong>Address:</strong> {customer.address}</p>
                    <p><strong>Contact:</strong> {customer.mobile1 || customer.mobile2}</p>
                </Card.Body>
            </Card>

            <Tabs defaultActiveKey="meterAddress" className="mb-4">
                <Tab eventKey="meterAddress" title="Meter Address">
                    <Card className="p-3">
                        <Row>
                            <Col md={4}><Form.Group><Form.Label>Latitude</Form.Label><Form.Control type="text" name="latitude" value={form.latitude || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Longitude</Form.Label><Form.Control type="text" name="longitude" value={form.longitude || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Near Meter Number</Form.Label><Form.Control type="text" name="nearMeterNumber" value={form.nearMeterNumber || ''} onChange={handleChange} /></Form.Group></Col>
                        </Row>
                        <Row className="mt-3">
                            <Col md={4}><Form.Group><Form.Label>Pole No.</Form.Label><Form.Control type="text" name="poleNo" value={form.poleNo || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Route Code</Form.Label><Form.Control type="text" name="routeCode" value={form.routeCode || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Sequence</Form.Label><Form.Control type="text" name="sequence" value={form.sequence || ''} onChange={handleChange} /></Form.Group></Col>
                        </Row>
                    </Card>
                </Tab>

                <Tab eventKey="serviceDetails" title="Meter Service Details">
                    <Card className="p-3">
                        <Row>
                            <Col md={4}><Form.Group><Form.Label>Bill Deposit</Form.Label><Form.Control type="text" name="billDeposit" value={form.billDeposit || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Feeder Number</Form.Label><Form.Control type="text" name="feederNumber" value={form.feederNumber || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Meter Class</Form.Label><Form.Control type="text" name="meterClass" value={form.meterClass || ''} onChange={handleChange} /></Form.Group></Col>
                        </Row>
                        <Row className="mt-3">
                            <Col md={4}><Form.Group><Form.Label>Total Cost of Materials</Form.Label><Form.Control type="text" name="totalCostMaterials" value={form.totalCostMaterials || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Type of Meter</Form.Label><Form.Control type="text" name="typeOfMeter" value={form.typeOfMeter || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Connected Load</Form.Label><Form.Control type="text" name="connectedLoad" value={form.connectedLoad || ''} onChange={handleChange} /></Form.Group></Col>
                        </Row>
                        <Row className="mt-3">
                            <Col md={4}><Form.Group><Form.Label>Total Cost of Labor and Equipment</Form.Label><Form.Control type="text" name="totalCostLaborEquip" value={form.totalCostLaborEquip || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Size of Conductor</Form.Label><Form.Control type="text" name="conductorSize" value={form.conductorSize || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Size of Transformer</Form.Label><Form.Control type="text" name="transformerSize" value={form.transformerSize || ''} onChange={handleChange} /></Form.Group></Col>
                        </Row>
                        <Row className="mt-3">
                            <Col md={4}><Form.Group><Form.Label>Others</Form.Label><Form.Control type="text" name="others" value={form.others || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Protection</Form.Label><Form.Control type="text" name="protection" value={form.protection || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Transformer Number</Form.Label><Form.Control type="text" name="transformerNumber" value={form.transformerNumber || ''} onChange={handleChange} /></Form.Group></Col>
                        </Row>
                    </Card>
                </Tab>

                <Tab eventKey="attachments" title="Attachments">
                    <Card className="p-3 mb-4">
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3">
                                <Form.Label>Upload Files</Form.Label>
                                <Form.Control type="file" multiple onChange={handleFileChange} />
                            </Form.Group>
                            <Button variant="primary" type="submit">
                                Save for verification
                            </Button>
                        </Form>
                    </Card>
                </Tab>
            </Tabs>
        </div>
    );
};

export default CustomerMeterForm;
